export default {"src":"/_next/static/media/googleplay-tv2-play.f2b9eb92.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};